/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * htoken API
 * OpenAPI spec version: v1
 */
export const CurrentKycDtoStatus = {
    NOT_STARTED: 'NOT_STARTED',
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
};
//# sourceMappingURL=currentKycDtoStatus.js.map